import { call, put, takeEvery, fork } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import * as types from './leadershipBulkUpdateActionType';
import * as actions from './leadershipBulkUpdateAction';
import * as services from './leadershipBulkUpdateServices';

//------------------Rad Leadership - start------------------//
function* fetchRadLeadershipSaga(action) {
    try {
        const response = yield call(services.getAllRadLeadership);
        if (response?.success) {
            yield put(actions.fetchRadLeadershipSuccess(response.values));
        } else {
            yield put(actions.fetchRadLeadershipFailure('No data found'));
        }
    } catch (error) {
        let errorMessage = 'Failed to fetch provider leadership data';
        console.error('Provider Leadership Bulk Update API Error:', {
            status: error.response?.status,
            message: errorMessage,
            data: error.response?.data,
            timestamp: new Date().toISOString()
        });
        yield put(actions.fetchRadLeadershipFailure(errorMessage));
    }
}

function* saveRadLeadershipBulkUpdateSaga(action) {
    try {
        // Call the API
        const response = yield call(services.saveRadLeadershipBulkUpdate, action.payload);

        if (response && response.success === true) {
            // Dispatch success action
            yield put(actions.radLeadershipBulkUpdateSuccess(response));

            Swal.fire({
                title: 'Success',
                text: 'Successfully Saved Provider Leadership Bulk Update',
                icon: 'success',
                confirmButtonText: 'OK',
                confirmButtonColor: '#8b5cf6',
                showCloseButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                customClass: {
                    popup: 'custom-success-popup',
                    title: 'custom-success-title',
                    content: 'custom-success-content',
                    confirmButton: 'custom-success-button'
                }
            });

            // Call delete API to remove user session after successful save
            try {
                yield call(services.deleteRadLeadershipBulkUpdateUser, action.payload.CreatedBy || 0);
            } catch (deleteError) {
                console.error('Failed to delete user session after save:', deleteError);
            }

            yield put(actions.fetchRadLeadershipRequest());

        } else if (response && response.success === false) {

            const errorMessage = response.errorMessage || 'Failed to save Provider Leadership Bulk Update';

            // Dispatch failure action with the specific error message
            yield put(actions.radLeadershipBulkUpdateFailure(errorMessage));

            // Show error notification with the API error message
            Swal.fire({
                title: 'Oops',
                text: errorMessage,
                icon: 'error',
                confirmButtonText: 'OK',
                confirmButtonColor: '#ef4444',
                showCloseButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                customClass: {
                    popup: 'custom-error-popup',
                    title: 'custom-error-title',
                    content: 'custom-error-content',
                    confirmButton: 'custom-error-button'
                }
            });

        } else {
            // Unexpected response format
            const errorMessage = 'Unexpected response from server';

            console.error('Save Provider Leadership Bulk Update Unexpected Response:', {
                response: response,
                timestamp: new Date().toISOString()
            });

            yield put(actions.radLeadershipBulkUpdateFailure(errorMessage));

            Swal.fire({
                title: 'Error!',
                text: errorMessage,
                icon: 'error',
                confirmButtonText: 'OK',
                confirmButtonColor: '#ef4444'
            });
        }

    } catch (error) {
        let errorMessage = 'Failed to save Provider Leadership Bulk Update';

        console.error('Save Provider Leadership Bulk Update Error:', {
            error: error,
            payload: action.payload,
            timestamp: new Date().toISOString()
        });

        // Check if it's a network or API error
        if (error?.response?.data) {
            errorMessage = error.response.data.errorMessage || error.response.data.message || errorMessage;
        } else if (error?.message) {
            errorMessage = error.message;
        }

        // Dispatch failure action with error
        yield put(actions.radLeadershipBulkUpdateFailure(errorMessage));

        // Show error notification
        Swal.fire({
            title: 'Error!',
            text: errorMessage,
            icon: 'error',
            confirmButtonText: 'OK',
            confirmButtonColor: '#ef4444'
        });
    }
}

function* checkRadLeadershipEditAccessSaga(action) {
    try {
        const response = yield call(services.checkRadLeadershipEditAccess, action.payload);

        if (response && response.success === true) {
            // User can edit - dispatch success
            yield put(actions.checkRadLeadershipEditAccessSuccess(response));
        } else if (response && response.success === false) {
            // Someone else is editing - show error message
            yield put(actions.checkRadLeadershipEditAccessFailure(response.errorMessage || 'Someone else is editing'));

            // Show error in a swal popup
            Swal.fire({
                title: 'Error!',
                text: response.errorMessage || 'Someone is already working on Provider Leadership Bulk Update',
                icon: 'error',
                confirmButtonText: 'OK',
                confirmButtonColor: '#8b5cf6',
                showCloseButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                customClass: {
                    popup: 'custom-error-popup',
                    title: 'custom-error-title',
                    content: 'custom-error-content',
                    confirmButton: 'custom-error-button'
                }
            });
        } else {
            yield put(actions.checkRadLeadershipEditAccessFailure('Failed to check edit access'));
        }
    } catch (error) {
        console.error('Check Provider Leadership Edit Access Error:', error);
        yield put(actions.checkRadLeadershipEditAccessFailure('Failed to check edit access'));
        Swal.fire('Error', 'Failed to check edit access', 'error');
    }
}

function* deleteRadLeadershipBulkUpdateUserSaga(action) {
    try {
        const response = yield call(services.deleteRadLeadershipBulkUpdateUser, action.payload);

        if (response && response.success === true) {
            // User session deleted successfully
            yield put(actions.deleteRadLeadershipBulkUpdateUserSuccess(response));
        } else {
            yield put(actions.deleteRadLeadershipBulkUpdateUserFailure(response?.errorMessage || 'Failed to delete user session'));
        }
    } catch (error) {
        console.error('Delete Provider Leadership Bulk Update User Error:', error);
        yield put(actions.deleteRadLeadershipBulkUpdateUserFailure('Failed to delete user session'));
    }
}
//------------------Provider Leadership - end------------------//

export default function* watchLeadershipBulkUpdateSaga() {
      //Rad Leadership Bulk Upload - start
       yield takeEvery(types.FETCH_RAD_LEADERSHIP_REQUEST, fetchRadLeadershipSaga);
       yield takeEvery(types.RAD_LEADERSHIP_BULK_UPDATE_REQUEST, saveRadLeadershipBulkUpdateSaga);
       yield takeEvery(types.CHECK_RAD_LEADERSHIP_EDIT_ACCESS_REQUEST, checkRadLeadershipEditAccessSaga);
       yield takeEvery(types.DELETE_RAD_LEADERSHIP_BULK_UPDATE_USER_REQUEST, deleteRadLeadershipBulkUpdateUserSaga);
       //Rad Leadership Bulk Upload - end
}   